var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFolder = function SvgFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 6.75h-7.94L9.75 4.19a1.49 1.49 0 0 0-1.06-.44H3.75a1.5 1.5 0 0 0-1.5 1.5v13.558a1.444 1.444 0 0 0 1.442 1.442h16.641a1.42 1.42 0 0 0 1.417-1.417V8.25a1.5 1.5 0 0 0-1.5-1.5m-16.5-1.5h4.94l1.5 1.5H3.75zm16.5 13.5H3.75V8.25h16.5z"
  })));
};
export default SvgFolder;